import type { ApiRoute, NoBody, NoPathParams } from "../api"
import type { ColorsView } from "../common/colors/ColorsView"
import type { GetColorsQueryParams } from "../common/colors/GetColorsQueryParams"

export const getColorsRoute: ApiRoute<NoPathParams, GetColorsQueryParams, NoBody, ColorsView> = {
	buildUrl: () => "/colors",
	method: "get",
	path: "/colors",
}
